import axios from "axios";
import NProgress from "nprogress";
import Vue from "vue";
const client = axios.create({
  baseURL: Vue.prototype.$apiUrl,
  withCredentials: false
});

client.interceptors.request.use(config => {
  NProgress.start();
  return config;
});

client.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    return Promise.reject(error.response);
  }
);

function GetHomeworkShort(studentid, classlessonid) {
  const params = {
    studentid: studentid,
    classlessonid: classlessonid,
    action: "hwshort"
  };
  return client.get("homework.php", { params });
}

function GetHomework(id) {
  const params = {
    id: id,
    action: "hw"
  };
  return client.get("homework.php", { params });
}

function GetHomeworkByStudent(id) {
  const params = {
    id: id,
    action: "hwbystudent"
  };
  return client.get("homework.php", { params });
}

function GetHomeworkByTeacher(filter) {
  const params = {
    id: filter.id,
    searchtype: filter.searchtype,
    dtfrom: filter.start,
    dtto: filter.end,
    action: "hwbyteacher"
  };
  return client.get("homework.php", { params });
}

function UpdateResponse(response) {
  response.action = "studentupdate";
  return client.put("homework.php", response);
}

function UpdateReview(result) {
  result.action = "teacherupdate";
  return client.put("homework.php", result);
}

export { GetHomeworkShort, GetHomeworkByStudent, GetHomeworkByTeacher, GetHomework, UpdateResponse, UpdateReview };
